
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#ccd3df","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M8 2v3","stroke-width":"1.5"}}),_c('path',{attrs:{"data-name":"Vector","d":"M16 2v3","stroke-width":"1.5"}}),_c('path',{attrs:{"data-name":"Vector","d":"M3.5 9.09h17","stroke-width":"1.5","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M21 8.5V17c0 3-1.5 5-5 5H8c-3.5 0-5-2-5-5V8.5c0-3 1.5-5 5-5h8c3.5 0 5 2 5 5z","stroke-width":"1.5"}}),_c('path',{attrs:{"data-name":"Vector","d":"M15.695 13.7h.005M15.695 16.7h.005M11.996 13.7h.005M11.996 16.7h.005M8.295 13.7H8.3M8.294 16.7h.009","stroke-width":"2","opacity":".4"}})])])
          )
        }
      }
    